import React, { FC } from 'react';
import { Modal } from '@eika/modal';
import { ModalDialogProps } from '@eika/modal/src/ModalDialogTypes';
import { StandardButton } from '@eika/button';
import { RichIconTypes } from '@eika/rich-icon';
import Card from '@eika/card/src/Card';

type NothingChangedModalProps = ModalDialogProps;
const NothingChangedModal: FC<NothingChangedModalProps> = ({ onClose, open }) => {
    return (
        <Modal onClose={onClose} open={open} className="set-downscaling-modal">
            <Card title="Du har allerede denne spareprofilen" isModal icon={RichIconTypes.DATAFEIL_3}>
                <article>Det er ikke mulig å endre til en spareprofil som du allerede har.</article>
                <div className="button-row">
                    <StandardButton size="large" buttonType="negative" onClick={onClose} placeholder="Avbryt">
                        Avbryt
                    </StandardButton>
                </div>
            </Card>
        </Modal>
    );
};

export default NothingChangedModal;
